import MatchBasicModel from "../../../Football/Models/Match/MatchBasicModel";
import PlayerBasicModel from "../../../Football/Models/Player/PlayerBasicModel";

export default class PotmUserVotesModel {
  public matchId: string = null;
  public matchModel: MatchBasicModel | null = null;
  public playerId: string = null;
  public playerModel: PlayerBasicModel | null = null;
  public createdAt: string = null;
}
